import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import config from '../config';
import {devOpsUrlFor} from './devOpsUrl';
import {directoryPathFor} from './directoryUrl';

/**
 * FNP-2017: user management moved to Flexi Directory. A bookmarked Console
 * URL under /users lands on the same page there instead of the Console's 404
 * page. `directoryPathFor` handles the one path Directory does not have.
 *
 * Same shape as RedirectToDevOps (FNP-1636). `location.replace`, so the dead
 * Console URL does not stay in the history.
 */
export const RedirectToDirectory = ({base = config.platform.directory}: {base?: string}) => {
    const {pathname, search, hash} = useLocation();

    useEffect(() => {
        window.location.replace(devOpsUrlFor(base, directoryPathFor(pathname), search, hash));
    }, [base, pathname, search, hash]);

    return null;
};
